{
  "brand": "Dashboard Garage",
  "nav": {
    "devices": "Urządzenia",
    "connections": "Źródła danych",
    "settings": "Ustawienia",
    "logout": "Wyloguj",
    "exitDemo": "Wyjdź z demo",
    "skip": "Przejdź do treści",
    "main": "Główna",
    "demo": "Demo",
    "language": "Język"
  },
  "demo": {
    "bannerText": "Tryb demo: wszystko, co zmienisz, zostaje w tej prywatnej piaskownicy i znika za {{hours}} h.",
    "cta": "Chcesz to mieć na biurku? Poproś o wycenę",
    "landing": {
      "eyebrow": "Wypróbuj samodzielnie",
      "title": "Pokaż swoje KPI na prawdziwych zegarach",
      "lead": "To ten sam panel, z którego korzystają nasi klienci. Przypisuj KPI do wskaźników oryginalnego zestawu zegarów, ustawiaj skale, progi i kolory, przełączaj zestawy raportów i patrz, jak wskazówki poruszają się na żywo na przykładowych danych ze sklepu internetowego.",
      "points": [
        "Bez konta, bez e-maila",
        "Własna prywatna piaskownica na 24 godziny",
        "Tylko przykładowe dane: niczego nie trzeba podłączać"
      ],
      "enter": "Wejdź do demo",
      "entering": "Przygotowujemy demo…",
      "error": "Nie udało się teraz uruchomić demo. Spróbuj ponownie za chwilę.",
      "haveAccount": "Jesteś klientem? Zaloguj się"
    }
  },
  "login": {
    "title": "Logowanie",
    "email": "E-mail",
    "password": "Hasło",
    "submit": "Zaloguj się",
    "error": "Nieprawidłowy e-mail lub hasło.",
    "tryDemo": "Tylko się rozglądasz? Wypróbuj demo"
  },
  "devices": {
    "title": "Twoje urządzenia",
    "empty": "Nie masz jeszcze żadnych urządzeń.",
    "open": "Konfiguruj",
    "status": {
      "online": "Online",
      "offline": "Offline",
      "stale": "Dane nieaktualne",
      "never_connected": "Jeszcze nie połączono"
    },
    "lastSeen": "Ostatnio widziane",
    "firmware": "Firmware",
    "signal": "Sygnał Wi-Fi",
    "syncPending": "Ostatnie zmiany nie dotarły jeszcze do urządzenia"
  },
  "configurator": {
    "reportSets": "Zestawy raportów",
    "reportSetsHint": "Na urządzeniu aktywny zestaw wybiera się pokrętłem w podstawie.",
    "addSet": "Dodaj zestaw",
    "newSetName": "Nowy zestaw",
    "position": "Pozycja pokrętła {{n}}",
    "colorMode": "Kolory statusu",
    "colorModeStatus": "Według statusu (zielony / bursztynowy / czerwony)",
    "colorModeFixed": "Stały kolor",
    "clickGauge": "Kliknij wskaźnik, aby przypisać KPI.",
    "unassigned": "Nieprzypisany",
    "stale": "Nieaktualne",
    "alert": "Alert",
    "onUnit": "teraz na urządzeniu",
    "setName": "Nazwa zestawu",
    "removeSet": "Usuń ten zestaw",
    "removeSetConfirm": "Tak, usuń zestaw i jego wskaźniki"
  },
  "editor": {
    "title": "{{gauge}}",
    "dialRange": "Skala na tarczy: {{min}}–{{max}} {{unit}}",
    "metric": "KPI",
    "noMetric": "Nieprzypisany",
    "unitLabel": "Opis na tarczy",
    "kpiMin": "KPI na minimum skali",
    "kpiMax": "KPI na maksimum skali",
    "multiplier": "Mnożnik skali",
    "multiplierHint": "Liczby na tarczy = KPI ÷ mnożnik (nadrukowane jako ×1000 itd.)",
    "redline": "Czerwone pole zaczyna się od",
    "alertTitle": "Alert",
    "alertWhen": "Alert, gdy KPI jest",
    "above": "powyżej",
    "below": "poniżej",
    "none": "bez alertu",
    "threshold": "Próg",
    "alertNeedle": "Przy alercie wychyl wskazówkę na czerwone pole",
    "statusTitle": "Kolor statusu",
    "statusNone": "Bez koloru statusu",
    "higherBetter": "Im więcej, tym lepiej",
    "lowerBetter": "Im mniej, tym lepiej",
    "amberAt": "Bursztynowy od",
    "redAt": "Czerwony od",
    "damping": "Wygładzanie wskazówki",
    "dampingValue": "{{ms}} ms do ustabilizowania",
    "save": "Zapisz wskaźnik",
    "saving": "Zapisywanie…",
    "saved": "Zapisano",
    "remove": "Wyczyść wskaźnik",
    "current": "Bieżąca wartość",
    "invalid": "Sprawdź wartości: {{details}}",
    "lightMode": "Jak sterowana jest ta kontrolka",
    "lightModeRule": "Regułą opartą na KPI",
    "lightModeManual": "Ręcznie (stały stan)",
    "lightState": "Stan kontrolki",
    "lightOff": "Wyłączona",
    "lightOn": "Włączona",
    "lightBlink": "Miga",
    "lightManualHint": "Kontrolka pozostaje w tym stanie, dopóki go nie zmienisz: przydatne do sprawdzenia kontrolki albo ręcznego oznaczenia czegoś.",
    "lightWhen": "Zapal, gdy KPI jest",
    "lightBlinkAlways": "Migaj zawsze, gdy kontrolka jest włączona",
    "lightBlinkAt": "Zacznij migać od",
    "lightBlinkAtHint": "Opcjonalny drugi próg, dalej {{direction}}: kontrolka najpierw świeci stale, a zaczyna migać, gdy KPI się pogorszy.",
    "optional": "opcjonalnie",
    "alertLight": "Kontrolka ostrzegawcza przy alercie",
    "noLight": "Bez kontrolki",
    "staleLight": "Kontrolka ostrzegawcza przy nieaktualnych danych"
  },
  "connections": {
    "title": "Źródła danych",
    "lead": "Skąd pochodzą wartości Twoich KPI. Dane dostępowe są szyfrowane na naszym serwerze i po zapisaniu nigdy więcej nie są wyświetlane.",
    "demoNote": "W demo dane pochodzą z symulowanego sklepu internetowego. Pozostałe źródła to przykłady tego, co możesz podłączyć we własnym panelu; nie da się tu wpisać prawdziwych danych dostępowych.",
    "example": "Przykład",
    "lastOk": "Ostatnie udane pobranie",
    "lastError": "Ostatni błąd",
    "never": "nigdy",
    "test": "Testuj",
    "testing": "Testowanie…",
    "secretSet": "Dane dostępowe zapisane",
    "types": {
      "bigquery": "BigQuery",
      "ga4": "Google Analytics 4",
      "meta": "Meta Ads i Pixel",
      "google_ads": "Google Ads",
      "search_console": "Google Search Console",
      "woocommerce": "WooCommerce",
      "shoper": "Shoper",
      "stripe": "Stripe",
      "youtube": "YouTube",
      "postgres": "PostgreSQL",
      "rest": "REST API",
      "webhook": "Webhook (push)",
      "customer_endpoint": "Własny endpoint",
      "sample": "Dane przykładowe"
    },
    "add": "Dodaj źródło danych",
    "cancel": "Anuluj",
    "create": "Zapisz źródło danych",
    "delete": "Usuń",
    "name": "Nazwa",
    "type": "Typ",
    "fields": {
      "project": "ID projektu",
      "dataset": "Zbiór danych",
      "table": "Tabela",
      "location": "Lokalizacja (opcjonalnie)",
      "serviceAccount": "Klucz konta usługi (JSON)",
      "mode": "Co odczytywać",
      "modePublic": "Statystyki publiczne (klucz API)",
      "modeOwner": "Analityka właściciela (Twój klient OAuth)",
      "channel": "ID kanału (UC…) lub @nazwa",
      "apiKey": "Klucz API (ograniczony do YouTube Data API v3)",
      "publishing": "Status Twojej aplikacji OAuth",
      "testing": "Testowanie (tokeny wygasają po 7 dniach)",
      "production": "W wersji produkcyjnej",
      "clientId": "ID klienta OAuth",
      "clientSecret": "Tajny klucz klienta OAuth",
      "host": "Host",
      "port": "Port",
      "database": "Baza danych",
      "user": "Użytkownik (zalecany tylko do odczytu)",
      "ssl": "Użyj SSL",
      "password": "Hasło",
      "url": "URL (https)",
      "headerName": "Nazwa nagłówka",
      "headerValue": "Wartość nagłówka (token)",
      "endpointToken": "Token Bearer",
      "propertyId": "ID usługi GA4",
      "propertyIdHint": "Liczba z Administracja → Szczegóły usługi, a nie identyfikator pomiaru G-…",
      "adAccountId": "ID konta reklamowego",
      "adAccountIdHint": "Numer z Menedżera reklam, z prefiksem act_ lub bez.",
      "pixelId": "ID piksela (opcjonalnie)",
      "pixelIdHint": "Potrzebne tylko do liczby zdarzeń piksela.",
      "metaToken": "Token dostępu użytkownika systemowego (ads_read)",
      "customerId": "ID klienta",
      "customerIdHint": "10 cyfr, widoczne u góry Google Ads.",
      "loginCustomerId": "ID konta menedżera (opcjonalnie)",
      "loginCustomerIdHint": "Uzupełnij, jeśli masz dostęp do konta przez konto menedżera (MCC).",
      "developerToken": "Token programisty (developer token)",
      "siteUrl": "Usługa",
      "siteUrlHint": "Dokładnie tak jak w Search Console: https://example.com/ lub sc-domain:example.com",
      "shopUrl": "Adres sklepu (https)",
      "consumerKey": "Klucz klienta (consumer key)",
      "consumerSecret": "Tajny klucz klienta (consumer secret)",
      "currency": "Waluta",
      "currencyHint": "Kod 3-literowy, np. PLN. Płatności w innych walutach nie są liczone.",
      "stripeKey": "Klucz ograniczony API (odczyt: Charges, Balance)",
      "timezone": "Strefa czasowa sklepu",
      "webapiLogin": "Login użytkownika WebAPI",
      "webapiPassword": "Hasło użytkownika WebAPI"
    },
    "secretHint": "Szyfrowane na naszym serwerze. Nigdy więcej nie jest wyświetlane, nawet Tobie.",
    "guide": "Instrukcja konfiguracji",
    "webhookCreated": "Webhook gotowy. Skopiuj token teraz: nie zostanie pokazany ponownie.",
    "webhookUrl": "URL webhooka",
    "webhookToken": "Token",
    "webhookExample": "Przykład",
    "oauth": {
      "not_authorized": "Brak autoryzacji",
      "ok": "Autoryzowano",
      "expiring": "Wkrótce wygaśnie",
      "expired": "Autoryzacja wygasła",
      "expiresOn": "Autoryzacja wygasa {{date}} (aplikacja w trybie Testing).",
      "authorize": "Autoryzuj przez Google",
      "reauthorize": "Autoryzuj ponownie",
      "redirect": "Adres przekierowania (redirect URI) do dodania w Twoim kliencie OAuth:",
      "result": {
        "ok": "Autoryzacja Google zapisana.",
        "denied": "Autoryzacja została anulowana.",
        "failed": "Autoryzacja nie powiodła się: zobacz błąd poniżej.",
        "invalid_state": "Link autoryzacyjny wygasł. Spróbuj ponownie."
      }
    },
    "metrics": {
      "title": "KPI",
      "lead": "Każde KPI to jedna liczba odczytywana ze źródła danych. KPI przypisujesz do wskaźników w konfiguratorze.",
      "add": "Dodaj KPI",
      "name": "Nazwa KPI",
      "source": "Źródło danych",
      "unit": "Jednostka",
      "refresh": "Odświeżaj co (sekundy)",
      "staleAfter": "Nieaktualne po (minuty, puste = domyślnie)",
      "latest": "Ostatnia",
      "none": "brak wartości",
      "delete": "Usuń",
      "sourceFields": {
        "kpi_name": "kpi_name w tabeli",
        "metric": "Statystyka",
        "sql": "SQL (musi zwracać jeden wiersz z kolumną \"value\")",
        "json_path": "Ścieżka JSON, np. data.revenue",
        "key": "Klucz w przesyłanym JSON-ie",
        "kpi": "Przykładowe KPI",
        "ga4_metric": "Dane GA4 (nazwa w API)",
        "ga4_range": "Okres",
        "ga4_range_hint": "Dni liczone są w strefie czasowej usługi GA4. „Ostatnie 30 minut” obsługuje tylko kilka danych, np. activeUsers.",
        "meta_metric": "Dane Meta",
        "meta_range_hint": "Dane reklam liczone są według dni konta reklamowego; „ostatnie 7 / 28 dni” to pełne dni bez dzisiejszego. Dane piksela (pixel:…) to liczba zdarzeń z ostatniej godziny lub 24 godzin.",
        "ads_range_hint": "Dni liczone są w strefie czasowej konta Google Ads. „Ostatnie 7 / 30 dni” to pełne dni bez dzisiejszego.",
        "gsc_range_hint": "Search Console kończy liczyć dzień po dwóch–trzech dniach, dlatego każdy okres kończy się trzy dni temu.",
        "woo_range_hint": "Tydzień, miesiąc i rok to bieżące okresy do dziś. average_sales to średnia dzienna w okresie.",
        "stripe_range_hint": "„Dzisiaj” zaczyna się o północy UTC. KPI salda nie zależą od okresu.",
        "shoper_range_hint": "„Dzisiaj” zaczyna się o północy w strefie czasowej sklepu. Liczone są wszystkie zamówienia złożone w okresie, niezależnie od statusu."
      },
      "ga4Ranges": {
        "realtime": "Ostatnie 30 minut (czas rzeczywisty)",
        "today": "Dzisiaj",
        "yesterday": "Wczoraj",
        "7d": "Ostatnie 7 dni",
        "28d": "Ostatnie 28 dni",
        "month_to_date": "Ten miesiąc do dziś"
      },
      "metaRanges": {
        "today": "Dzisiaj",
        "yesterday": "Wczoraj",
        "7d": "Ostatnie 7 dni",
        "28d": "Ostatnie 28 dni",
        "month_to_date": "Ten miesiąc do dziś",
        "last_hour": "Ostatnia godzina",
        "24h": "Ostatnie 24 godziny"
      },
      "adsRanges": {
        "today": "Dzisiaj",
        "yesterday": "Wczoraj",
        "7d": "Ostatnie 7 dni",
        "30d": "Ostatnie 30 dni",
        "month_to_date": "Ten miesiąc do dziś"
      },
      "gscRanges": {
        "7d": "7 dni",
        "28d": "28 dni",
        "90d": "90 dni"
      },
      "wooRanges": {
        "today": "Dzisiaj",
        "week": "Ten tydzień",
        "month": "Ten miesiąc",
        "last_month": "Poprzedni miesiąc",
        "year": "Ten rok"
      },
      "stripeRanges": {
        "today": "Dzisiaj",
        "24h": "Ostatnie 24 godziny",
        "7d": "Ostatnie 7 dni"
      },
      "shoperRanges": {
        "today": "Dzisiaj",
        "24h": "Ostatnie 24 godziny",
        "7d": "Ostatnie 7 dni",
        "30d": "Ostatnie 30 dni"
      }
    }
  },
  "settings": {
    "title": "Ustawienia",
    "staleTitle": "Gdy dane są nieaktualne",
    "staleAfter": "Uznawaj wartości za nieaktualne po (minuty)",
    "staleNeedle": "Wskazówka przy nieaktualnych danych",
    "staleHold": "Zatrzymaj na ostatniej wartości",
    "staleMin": "Opuść na minimum skali",
    "colors": "Kolory",
    "ok": "OK",
    "warn": "Ostrzeżenie",
    "alert": "Alert",
    "staleColor": "Nieaktualne",
    "neutral": "Neutralny",
    "save": "Zapisz ustawienia",
    "saved": "Zapisano"
  },
  "consent": {
    "title": "Pliki cookie i analityka",
    "text": "Analitycznych plików cookie używamy tylko za Twoją zgodą, żeby ulepszać panel i demo. Nic nie jest ładowane, zanim wybierzesz.",
    "accept": "Zaakceptuj wszystkie",
    "reject": "Odrzuć wszystkie"
  },
  "common": {
    "loading": "Wczytywanie…",
    "error": "Coś poszło nie tak.",
    "retry": "Spróbuj ponownie",
    "notFound": "Nie znaleziono strony",
    "back": "Wstecz"
  },
  "guides": {
    "back": "Wróć do źródeł danych",
    "screenshot": "Miejsce na zrzut ekranu"
  },
  "health": {
    "title": "Stan urządzenia",
    "lastSeen": "Ostatni kontakt",
    "never": "nigdy",
    "activeSet": "Aktywny zestaw",
    "unknownSet": "Nieznany zestaw",
    "firmware": "Firmware",
    "signal": "Sygnał Wi-Fi",
    "uptime": "Czas pracy",
    "freeHeap": "Wolna pamięć",
    "token": "Token urządzenia",
    "rotationPending": "wydano nowy token, czekamy na urządzenie",
    "errors_one": "Urządzenie zgłosiło {{count}} błąd",
    "errors_few": "Urządzenie zgłosiło {{count}} błędy",
    "errors_many": "Urządzenie zgłosiło {{count}} błędów",
    "errors_other": "Urządzenie zgłosiło {{count}} błędu",
    "sync": {
      "synced": "Konfiguracja na urządzeniu jest aktualna (wersja {{current}}).",
      "pending": "Urządzenie ma wersję {{applied}}, najnowsza to {{current}}. Zmiany pobierze w ciągu kilku minut.",
      "unknown": "Urządzenie nie zgłosiło jeszcze wersji swojej konfiguracji."
    }
  },
  "deviceAdmin": {
    "add": "Dodaj urządzenie",
    "addManual": "Dodaj po numerze seryjnym",
    "pair": "Sparuj urządzenie",
    "pairTitle": "Sparuj urządzenie",
    "pairHint": "Połącz urządzenie z Wi-Fi: wyświetli 6-cyfrowy kod parowania. Wpisz go tutaj w ciągu 10 minut. Urządzenie zostanie przypisane do Twojego konta i samo pobierze swój token.",
    "pairCode": "Kod parowania",
    "pairCreate": "Sparuj",
    "paired": "{{serial}} jest teraz przypisane do Twojego konta. Urządzenie pobierze token w ciągu kilku sekund; potem przypisz KPI do jego wskaźników.",
    "repaired": "{{serial}} zostało sparowane ponownie. Zestawy raportów i wskaźniki pozostały bez zmian; urządzenie dostanie nowy token w ciągu kilku sekund.",
    "addTitle": "Dodaj urządzenie",
    "title": "Zarządzaj urządzeniem",
    "name": "Nazwa",
    "namePlaceholder": "np. Biurko w biurze",
    "serial": "Numer seryjny",
    "serialHint": "Podaj numer seryjny urządzenia (unikalny, np. DG-0002). Po zapisaniu dostaniesz token urządzenia: jest pokazywany tylko raz i trafia do konfiguracji firmware'u urządzenia.",
    "model": "Zestaw zegarów",
    "create": "Dodaj urządzenie",
    "rename": "Zmień nazwę",
    "tokenOnce": "Token dla {{serial}}. Skopiuj go teraz: nie zostanie pokazany ponownie.",
    "tokenHint": "Wpisz go w konfiguracji firmware'u urządzenia. Urządzenie wysyła go z każdym żądaniem (Authorization: Bearer …).",
    "copy": "Kopiuj",
    "copied": "Skopiowano",
    "done": "Gotowe",
    "rotate": "Wydaj nowy token",
    "rotateConfirm": "Tak, wydaj nowy token",
    "rotateHint": "Gdy token wyciekł albo urządzenie jest konfigurowane od nowa. Obecny token działa, dopóki urządzenie pierwszy raz nie użyje nowego.",
    "delete": "Usuń urządzenie",
    "deleteWarn": "To usunie {{serial}} wraz z zestawami raportów i przypisaniami wskaźników. Urządzenie przestanie otrzymywać dane.",
    "deleteConfirm": "Tak, usuń",
    "errors": {
      "serial_taken": "Urządzenie o tym numerze seryjnym jest już zarejestrowane.",
      "unknown_cluster_model": "Nieznany model zestawu zegarów.",
      "invalid_body": "Sprawdź nazwę i numer seryjny (3–40 znaków: litery, cyfry, - oraz _).",
      "pairing_code_invalid": "Ten kod jest nieprawidłowy albo wygasł. Sprawdź kod na urządzeniu lub uruchom na nim parowanie ponownie, aby dostać nowy.",
      "serial_registered_elsewhere": "To urządzenie jest zarejestrowane na innym koncie. Skontaktuj się z nami, aby je przenieść.",
      "rate_limited": "Zbyt wiele prób. Odczekaj minutę i spróbuj ponownie."
    }
  },
  "history": {
    "title": "Historia: {{name}}",
    "range": "Zakres czasu",
    "range24": "24 h",
    "range168": "7 dni",
    "empty": "Brak historii. Wartości pojawią się tutaj po pierwszym odpytaniu źródła danych.",
    "latest": "Ostatnia",
    "min": "Min",
    "max": "Maks",
    "summary": "Historia {{name}}: min {{min}}{{unit}}, maks {{max}}{{unit}}, ostatnia {{latest}}{{unit}}"
  }
}
